import React, { useContext } from "react";
import { Link as ScrollLink } from "react-scroll";
import { themeContext } from "../../../Context";
import "./Sectors.css";

const sectors = [
  {
    title: "المحطات النفطية",
    desc: "إدارة المحطات والمبيعات والمخزون والتقارير التشغيلية.",
  },
  {
    title: "فوترة الكهرباء والمياه",
    desc: "فوترة دورية ومتابعة الاشتراكات والتحصيل للمنشآت الخدمية.",
  },
  {
    title: "محلات الخياطة",
    desc: "أوامر الشغل والقياسات والتكاليف ومتابعة التنفيذ، مع مسار الخياط المطور.",
  },
  {
    title: "المراكز الطبية",
    desc: "تنظيم العمليات والفواتير والتقارير المالية للمراكز والعيادات.",
  },
  {
    title: "الإنتاج والتصنيع",
    desc: "متابعة المواد والتكاليف ومراحل الإنتاج والتقارير التشغيلية.",
  },
  {
    title: "المطاعم",
    desc: "المبيعات اليومية والمخزون ونقاط البيع ومستلزمات التشغيل.",
  },
  {
    title: "متعهد الحفلات والاستوديوهات",
    desc: "إدارة الحجوزات والخدمات والتصوير والتأجير والدعوات.",
  },
  {
    title: "تخليص الجمارك",
    desc: "متابعة معاملات التخليص والمستندات والتكاليف المرتبطة.",
  },
  {
    title: "الشيش",
    desc: "إدارة تشغيل منافذ الشيش والمبيعات والمخزون اليومي.",
  },
  {
    title: "الفنادق والاستراحات والشاليهات",
    desc: "إدارة الغرف والأجنحة والحجوزات والإيجار والتقارير المالية.",
  },
  {
    title: "الموارد البشرية",
    desc: "الموظفون والحضور والرواتب والصلاحيات المرتبطة بالتشغيل.",
  },
  {
    title: "شركات النقل",
    desc: "الرحلات والتذاكر ومتابعة حركة النقل والتحصيل.",
  },
  // {
  //   title: "خدمات التوصيل واللوجستيات",
  //   desc: "إدارة عمليات التوصيل والمتابعة والتقارير اللوجستية.",
  // },
  // {
  //   title: "الدعاية والإعلان",
  //   desc: "إدارة حملات وخدمات الدعاية والتكاليف والفواتير.",
  // },
  // {
  //   title: "مكاتب الخدمات التجارية",
  //   desc: "متابعة معاملات الاستيراد والشحن والخدمات التجارية.",
  // },
  // {
  //   title: "إدارة الترجمة",
  //   desc: "إدارة مشاريع الترجمة والملفات والتسليم والفواتير.",
  // },
  // {
  //   title: "المعامل والورش",
  //   desc: "أوامر العمل وتكاليف المواد والعمالة ومتابعة التنفيذ.",
  // },
  {
    title: "الأصول الثابتة",
    desc: "سجل الأصول والإهلاك والمتابعة المرتبطة بالحسابات.",
  },
];

const Sectors = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <section className="erp-sectors" id="erp-sectors">
      <div className="erp-section-head">
        <h2 style={{ color: darkMode ? "white" : undefined }}>
          أنظمتنا المتخصصة
        </h2>
        <p>
          حلول قطاعية جاهزة بجانب الوحدات الأساسية للحسابات والمبيعات والمشتريات
          والمخزون.
        </p>
      </div>
      <div className="sectors-grid">
        {sectors.map((sector) => (
          <article className="sector-item" key={sector.title}>
            <h3 style={{ color: darkMode ? "white" : undefined }}>{sector.title}</h3>
            <p>{sector.desc}</p>
            <ScrollLink
              to="contact"
              spy={true}
              smooth={true}
              offset={-40}
              className="erp-card-cta"
            >
              اطلب عرضاً
            </ScrollLink>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Sectors;
